import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AplicationService } from '@services/aplication/aplication.service';
import { Observable, throwError } from 'rxjs';
import { CampaignsTagsRepository } from './campaigns-tags.repository';
import { TagBulkResponse, TagResponse } from '../domain/tag.model';

@Injectable({
    providedIn: 'root',
})
export class CampaignsTagsApiService implements CampaignsTagsRepository {
    private readonly http = inject(HttpClient);
    private readonly aplicationService = inject(AplicationService);

    /**
     * Builds the roads-scoped base URL and invokes `request` with it. When no aplication
     * is selected, fails fast by returning an Observable error instead of throwing
     * synchronously, so callers' existing `catchError`/`finalize` pipelines still run.
     */
    private withTagsBaseUrl<T>(request: (baseUrl: string) => Observable<T>): Observable<T> {
        const roadId = this.aplicationService.selectedRoadId();

        if (!roadId) {
            return throwError(() => new Error('Cannot build tags request URL: no aplication selected'));
        }

        return request(`${environment.url}/prism-admin-campaigns-tags/v2/roads/${roadId}/tags`);
    }

    getTags(): Observable<TagResponse> {
        return this.withTagsBaseUrl((baseUrl) => this.http.get<TagResponse>(baseUrl));
    }

    uploadTagsCsv(file: File): Observable<TagBulkResponse> {
        const formData = new FormData();
        formData.append('file', file);

        return this.withTagsBaseUrl((baseUrl) => this.http.post<TagBulkResponse>(`${baseUrl}/bulk-tag`, formData));
    }
}
